import React from 'react';
import { Divider, Table, Text } from '@mantine/core';
import dayjs from 'dayjs';
import type { KlaviyoMetricType } from '@dr-pam/common-components/Enums/KlaviyoMetricType';
import type { ActivityLogEntry } from './KlaviyoTestFormTypes';

export type KlaviyoTestActivityLogProps = {
	activityLog: ActivityLogEntry[];
	labelFor: (metric: KlaviyoMetricType) => string;
};

export default function KlaviyoTestActivityLog(props: KlaviyoTestActivityLogProps) {
	const { activityLog, labelFor } = props;

	if (activityLog.length === 0) {
		return null;
	}

	return (
		<>
			<Divider mt="xl" mb="md" label="Activity log" />
			<Table>
				<Table.Thead>
					<Table.Tr>
						<Table.Th>Time</Table.Th>
						<Table.Th>Event</Table.Th>
						<Table.Th>Email</Table.Th>
						<Table.Th>Result</Table.Th>
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>
					{activityLog.map((entry) => (
						<Table.Tr key={entry.id}>
							<Table.Td>{dayjs(entry.sentAt).format('HH:mm:ss')}</Table.Td>
							<Table.Td>{labelFor(entry.metric)}</Table.Td>
							<Table.Td>{entry.email}</Table.Td>
							<Table.Td>
								<Text c={entry.success ? 'green' : 'red'} size="sm">
									{entry.success ? 'Queued' : `Failed: ${entry.message}`}
								</Text>
							</Table.Td>
						</Table.Tr>
					))}
				</Table.Tbody>
			</Table>
		</>
	);
}
